import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useWindowScroll } from 'react-use';
import { useIsMobile } from '@/hooks/useMobile';
import { DESKTOP_SCROLL_THRESHOLD } from '@/lib/constants';

/**
 * Returns `true` once the user has scrolled past a small threshold
 * (`y > 0` on mobile, `y > DESKTOP_SCROLL_THRESHOLD` on desktop).
 * Returns `false` during SSR and before hydration completes.
 */
export function useIsScrolled() {
  const $ = _c(2);
  const isMobile = useIsMobile();
  const state = useWindowScroll();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  bb0: {
    if (!mounted) {
      t2 = false;
      break bb0;
    }
    t2 = isMobile ? state.y > 0 : state.y > DESKTOP_SCROLL_THRESHOLD;
  }
  return t2;
}